"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateBgNames = void 0;
const namesMapping = {
    "bg_editor_8liens_01.jpg": "bg_collab_8liens_01.jpg",
    "BG_AlienFrens.jpg": "bg_editor_AlienFrens_01.jpg",
    "BG_Azuki_1.jpg": "bg_editor_Azuki_01.jpg",
    "BG_Azuki_2.jpg": "bg_editor_Azuki_02.jpg",
    "BG_Bored Ape Yacht Club.jpg": "bg_editor_BoredApes_01.jpg",
    "bg_collab_boredapes_tropofarmer_01.jpeg": "bg_collab_BoredApes_tropofarmer_01.jpg",
    "BG_Chainrunners_01.jpg": "bg_editor_ChainRunners_01.jpg",
    "BG_Chainrunners Foodalley.jpg": "bg_editor_ChainRunners_02.jpg",
    "BG_Cool Cats.jpg": "bg_editor_CoolCats_01.jpg",
    "bg__editor_CoolCats_02.jpg": "bg_editor_CoolCats_02.jpg",
    "BG_CrypToadz.jpg": "bg_editor_CrypToadz_01.jpg",
    "BG_Cryptomories_01.jpg": "bg_editor_Cryptomories_01.jpg",
    "BG_Cryptomories_Collab.jpg": "bg_collab_Cryptomories_02.jpg",
    "bg_editor_cryptomories_03.jpg": "bg_editor_Cryptomories_03.jpg",
    "bg_editor_cryptopunks_02.jpg": "bg_editor_Cryptopunks_02.jpg",
    "BG_Cyberkong.jpg": "bg_editor_CyberKongz_01.jpg",
    "BG_Gutter Cat Gang.jpg": "bg_editor_GutterCatGang_01.jpg",
    "bg_editor_haleybros_01.jpg": "bg_collab_HaleyBros_01.jpg",
    "BG_Bored Ape Kennel Club.jpg": "bg_editor_KennelClub_01.jpg",
    "BG_mfers.jpg": "bg_editor_MFers_01.jpg",
    "BG_Moonbirds.jpg": "bg_editor_Moonbirds_01.jpg",
    "BG_Sneaker Shop.jpg": "bg_editor_Supducks_01.jpg",
    "BG_World of Women.jpg": "bg_editor_WorldofWomen_01.jpg",
    "BG_Vegas Night.jpg": "bg_editor_Fillers_01.jpg",
    "BG_Concert Stage.jpg": "bg_editor_Fillers_02.jpg",
    "BG_Rooftop Bar.jpg": "bg_editor_Fillers_03.jpg",
    "BG_Chapel.jpg": "bg_editor_Fillers_04.jpg",
    "BG_Pool_Night.jpg": "bg_editor_Fillers_05.jpg",
    "BG_Parking Garage.jpg": "bg_editor_Fillers_06.jpg",
    "BG_Pool_Day.jpg": "bg_editor_Fillers_07.jpg",
    "BG_Penthouse.jpg": "bg_editor_Fillers_08.jpg",
    "BG_Casino.jpg": "bg_editor_Fillers_09.jpg",
    'BG_Mutant Ape Yacht Club.jpg': 'bg_editor_MutantApes_01.jpg',
};
const keysToReplace = Object.keys(namesMapping);
/**
 * This migration got introduced because we didnt have naming convention for background assets.
 * Now we have and we need to update the old assets with new naming therefore new cdn url
 */
const migrateBgNames = async (dialog) => {
    let dialogStr = JSON.stringify(dialog);
    keysToReplace.forEach((key) => {
        const pattern = new RegExp(key, 'g');
        dialogStr = dialogStr.replace(pattern, namesMapping[key]);
    });
    return JSON.parse(dialogStr);
};
exports.migrateBgNames = migrateBgNames;
//# sourceMappingURL=migrateBgNames.js.map